import moment from "moment";
import { getNameFromEmail } from "./StringUtils";

export function exportDocuments(catalogue, fileName) {
  const headers = {
    filedAt: "Filing Date",
    companyName: "Company Filing Name",
    borrowerName: "Borrower Name",
    cik: "CIK Number",
    filmNumber: "Film Num",
    ejvID: "EJV ID",
    dateEjvIdRecheckedTB: "Date EJV ID was re-checked to the BLUES",
    formType: "Form Type",
    exhibit: "Exhibit",
    titleName: "Title Name",
    agreementType: '"Agreement Type (O, A, A&R, Warrant or Waiver)"',
    signingDate: "Signing Date",
    prevAmendDate: "Previous Date being Amended",
    amendmentNumber: "Amendment number",
    loanAmount: '"Loan $$ Amount (only needed for O, A/R)"',
    arrangerOrBookrunner: "Lead Arranger/Bookrunner",
    inLoanConnector: "Does Loan Exist in Loan Connector",
    loanConnectorID: "Loan Connector Deal ID",
    borrowerInLC: "Does Borrower Exist in Loan Connector?",
    filingInLC: "Does Filing Entity exist in Loan Connector?",
    loanDocNo: "Loan Doc #",

    captureDate: "Date document was captured from SEC",
    uploadedToLC: "Date doc was uploaded to Loan Connector",

    formURL: "Filing URL",
    exhbitURL: "SEC.gov URL",
    analyst: "Analyst who recorded the document",
    analystLC: "Analyst who uploaded the document to Loan Connector",

    lcReceivedDate:
      "Date the filing was reviewed in Loan Connector for company presence",
    pixelEdgeComment: "PixelEdge Comment",
    refinitivComment: "Refinitiv Comment",
  };

  const exportArray = catalogue.map((catalogued) => {
    const entity = catalogued.filing.entities[0];

    return {
      filedAt: moment(catalogued.filing.filedAt.split("T")[0]).format("L"),
      companyName: catalogued.filing.companyName.replace(/,/g, ""),
      borrowerName: "",
      cik: catalogued.filing.cik,
      filmNumber: entity ? entity.filmNo : "",
      ejvID: "",
      dateEjvIdRecheckedTB: "",
      formType: catalogued.filing.formType.replace(/,/g, ""),
      exhibit: catalogued.exhibit ? catalogued.exhibit : catalogued.formType,
      titleName: "",
      agreementType: "",
      signingDate: "",
      prevAmendDate: "",
      amendmentNumber: "",
      loanAmount: "",
      arrangerOrBookrunner: "",
      inLoanConnector: "",
      loanConnectorID: "",
      borrowerInLC: "",
      filingInLC: "",
      loanDocNo: "",

      captureDate: moment(catalogued.createdAt).format("L"),
      uploadedToLC: "",

      formURL: catalogued.filing.linkToHtml,
      exhbitURL: catalogued.filing.documentFormatFiles.find((item) => {
        if (
          item.documentId === catalogued.documentId &&
          (item.type === catalogued.exhibit ||
            item.type === catalogued.formType)
        ) {
          return item;
        }
      }).documentUrl,
      analyst: getNameFromEmail(catalogued.email),
      analystLC: "",

      lcReceivedDate: moment(catalogued.createdAt).format("L"),
      pixelEdgeComment: "",
      refinitivComment: "",
    };
  });

  exportArray.unshift(headers);

  var csvString = "";
  for (var i = 0; i < exportArray.length; i++) {
    var line = "";
    for (var index in exportArray[i]) {
      if (line !== "") line += ",";
      line += exportArray[i][index];
    }
    csvString += line + "\r\n";
  }

  var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export function exportFilings(filings, fileName) {
  const headers = {
    filingDate: "Filing Date",
    filedAt: "Filed At",
    analyst: "Analyst Assigned",
    companyName: "Company Filing Name",
    cik: "CIK Number",
    fileNumber: "File Number",
    filmNumber: "Film Number (DCN)",
    formType: "Form Type",
    exhibit: "Exhibits",
    formURL: "Filing URL",
    fetchedAt: "Fetched At",
  };

  const exportArray = filings.map((filing) => {
    const entity = filing.entities[0];
    return {
      filingDate: moment(filing.filedAt).toDate().toLocaleDateString("en-US", {
        timeZone: "America/New_York",
      }),
      filedAt: moment(filing.filedAt).toDate().toLocaleTimeString("en-US", {
        timeZone: "America/New_York",
        hour: "2-digit",
        minute: "2-digit",
      }),
      analyst: filing?.assignedAnalyst?.analyst_name || "",
      companyName: filing.companyName.replace(/,/g, ""),
      cik: filing.cik,
      fileNumber: entity ? entity.fileNo : "",
      filmNumber: entity ? entity.filmNo : "",
      formType: filing.formType.replace(/,/g, ""),
      exhibits: filing.documentFormatFiles
        .map((item) => item.type)
        .join(" | ")
        .trim(),
      formURL: filing.linkToHtml,

      fetchedAt: filing.fetchedAtDate
        ? moment(filing.fetchedAtDate).format("L")
        : "n/a",
    };
  });

  exportArray.unshift(headers);

  var csvString = "";
  for (var i = 0; i < exportArray.length; i++) {
    var line = "";
    for (var index in exportArray[i]) {
      if (line !== "") line += ",";
      line += exportArray[i][index];
    }
    csvString += line + "\r\n";
  }

  var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
/* *** transform the numeric value into currency format ( below ) *** */
function currencyFormat(val) {
  let currency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0, // (For whole numbers, it will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (It will round-off 2500.99 to $2,501)
  });
  return currency.format(parseFloat(val));
}

/* *** export submitted filings data *** */
export function exportFormData(formsData, fileName) {
  const headers = {
    filing_date: "Filing Date",
    company_name: "Company Filing Name",
    borroweer_name: "Borrower Name",
    cik_number: "CIK Number",
    film_number: "Film Num",
    ejv_id: "EJV ID",
    ejv_date: "Date EJV ID was re-checked to the BLUES",
    form_type: "Form Type",
    exhibit: "Exhibit",
    title_name: "Title Name",
    agreement_type: '"Agreement Type (O, A, A&R, Warrant or Waiver)"',
    signing_date: "Signing Date",
    prev_amend_date: "Previous Date being Amended",
    amend_numb: "Amendment Number",
    loan_amount: '"Loan $$ Amount (only needed for O, A/R)"',
    book_runner: "Lead Arranger/Bookrunner",
    loan_exists_lc: "Does Loan Exist in Loan Connector",
    lc_deal_id: "Loan Connector Deal ID",
    borrower_exists_lc: "Does Borrower Exist in Loan Connector?",
    filing_entry_exists_lc: "Does Filing Entity exist in Loan Connector?",
    loan_doc_num: "Loan Doc #",
    doc_capture_date: "Date document was captured from SEC",
    doc_upload_lc_date: "Date doc was uploaded to Loan Connector",
    filing_url: "Filing Url",
    sec_url: "SEC.gov URL",
    analyst_name_who_recorded: "Analyst who recorded the document",
    analyst_name_who_upload:
      "Analyst who uploaded the document to Loan Connector",
    filing_review_date:
      "Date the filing was reviewed in Loan Connector for company presence",
    pixeledge_comment: "PixelEdge Comment",
    refinitive_comment: "Refinitiv Comment",
  };

  const exportArray = formsData.map((filing) => {
    return {
      filing_date: moment(filing.filing_date).format("MM/DD/YYYY"),
      company_name: `"${
        filing.company_name !== undefined && filing.company_name !== null
          ? filing.company_name
          : ""
      }"`,
      borrower_name: `"${
        filing.borrower_name !== undefined && filing.borrower_name !== null
          ? filing.borrower_name
          : ""
      }"`,
      cik_number: `"${
        filing.cik_number && filing.cik_number !== 0 ? filing.cik_number : ""
      }"`,
      film_number: `"${filing.film_number}"`,
      ejv_id: `"${
        filing.ejv_id && filing.ejv_id !== null && filing.ejv_id !== ""
          ? filing.ejv_id
          : ""
      }"`,
      ejv_date: filing.ejv_date
        ? moment(filing.ejv_date).format("MM/DD/YYYY")
        : "",
      form_type: filing.form_type,
      exhibit: filing.exhibit,
      title_name: `"${
        filing.title_name && filing.title_name !== null ? filing.title_name : ""
      }"`,
      agreement_type: `"${
        filing.agreement_type &&
        filing.agreement_type !== "-1" &&
        filing.agreement_type !== "0"
          ? filing.agreement_type
          : ""
      }"`,
      signing_date: filing.signing_date
        ? moment(filing.signing_date).format("MM/DD/YYYY")
        : "",
      prev_amend_date: filing.prev_amend_date
        ? moment(filing.prev_amend_date).format("MM/DD/YYYY")
        : "",
      amend_numb: `"${
        filing.amend_numb && filing.amend_numb !== null ? filing.amend_numb : ""
      }"`,
      loan_amount: `"${
        filing.loan_amount && filing.loan_amount !== "0"
          ? currencyFormat(filing.loan_amount)
          : ""
      }"`,
      book_runner: `"${
        filing.book_runner && filing.book_runner !== null
          ? filing.book_runner
          : ""
      }"`,
      loan_exists_lc:
        filing.loan_exists_lc &&
        filing.loan_exists_lc !== "0" &&
        filing.loan_exists_lc !== "-1"
          ? "Yes"
          : "No",
      lc_deal_id: `"${
        filing.lc_deal_id && filing.lc_deal_id !== null ? filing.lc_deal_id : ""
      }"`,
      borrower_exists_lc:
        filing.borrower_exists_lc &&
        filing.borrower_exists_lc !== "0" &&
        filing.borrower_exists_lc !== "-1"
          ? "Yes"
          : "No",
      filing_entry_exists_lc:
        filing.filing_entry_exists_lc &&
        filing.filing_entry_exists_lc !== "0" &&
        filing.filing_entry_exists_lc !== "-1"
          ? "Yes"
          : "No",
      loan_doc_num: `"${
        filing.loan_doc_num && filing.loan_doc_num !== null
          ? filing.loan_doc_num
          : ""
      }"`,
      doc_capture_date: filing.doc_capture_date
        ? moment(filing.doc_capture_date).format("MM/DD/YYYY")
        : "",
      doc_upload_lc_date: filing.doc_upload_lc_date
        ? moment(filing.doc_upload_lc_date).format("MM/DD/YYYY")
        : "",
      filing_url: `"${filing.filing_url}"`,
      sec_url: `"${filing.sec_url}"`,
      analyst_name_who_recorded: `"${
        filing.analyst_name_who_recorded &&
        filing.analyst_name_who_recorded !== null
          ? filing.analyst_name_who_recorded
          : ""
      }"`,
      analyst_name_who_upload: `"${
        filing.analyst_name_who_upload &&
        filing.analyst_name_who_upload !== null
          ? filing.analyst_name_who_upload
          : ""
      }"`,
      filing_review_date: filing.filing_review_date
        ? moment(filing.filing_review_date).format("MM/DD/YYYY")
        : "",
      pixeledge_comment: `"${
        filing.pixeledge_comment && filing.pixeledge_comment !== null
          ? filing.pixeledge_comment
          : ""
      }"`,
      refinitive_comment: `"${
        filing.refinitive_comment && filing.refinitive_comment !== null
          ? filing.refinitive_comment
          : ""
      }"`,
    };
  });

  exportArray.unshift(headers);

  var csvString = "";
  for (var i = 0; i < exportArray.length; i++) {
    var line = "";
    for (var index in exportArray[i]) {
      if (line !== "") line += ",";
      line += exportArray[i][index];
    }
    csvString += line + "\r\n";
  }
  var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
